export const diagnosisDialogStyles = {
  paper: {
    width: 'calc(100% - 32px)',
    maxWidth: 1230,
    height: 'calc(100vh - 32px)',
    maxHeight: 910,
    m: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.18)',
    overflow: 'hidden'
  },

  content: {
    flex: '1 1 auto',
    minHeight: 0,
    p: '16px 12px !important',
    overflow: 'hidden',
    bgcolor: '#FFFFFF'
  },

  contentGrid: {
    height: '100%',
    minHeight: 0,
    alignItems: 'stretch'
  },

  gridItem: {
    height: '100%',
    minHeight: 0,
    display: 'flex'
  },

  panel: {
    width: '100%',
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #DADCE0',
    borderRadius: '9px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden'
  },

  panelHeader: {
    minHeight: 40,
    flexShrink: 0,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #DADCE0',
    bgcolor: '#FAFAFA'
  },

  panelTitle: {
    color: '#424242',
    fontSize: 16,
    fontWeight: 500
  },

  searchRow: {
    minHeight: 50,
    flexShrink: 0,
    px: 2,
    py: 1.25,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    borderBottom: '1px solid #E0E0E0'
  },

  searchField: {
    flex: 1,
    minWidth: 0,

    '& .MuiOutlinedInput-root': {
      height: 45,
      borderRadius: '5px',
      bgcolor: '#FFFFFF',
      fontSize: 14
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D7D7D7'
    },

    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#BDBDBD'
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5597D5'
    },

    '& input::placeholder': {
      color: '#757575',
      opacity: 1
    }
  },

  addToggleButton: {
    width: 36,
    height: 36,
    flexShrink: 0,
    color: '#616161',

    '&:hover': {
      bgcolor: '#F1F5F9'
    }
  },

  manualRow: {
    minHeight: 68,
    flexShrink: 0,
    px: 2,
    py: 1.25,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    borderBottom: '1px solid #E0E0E0'
  },

  codeField: {
    width: 108,
    flexShrink: 0,

    '& .MuiOutlinedInput-root': {
      height: 45,
      borderRadius: '5px',
      fontSize: 14
    }
  },

  descriptionField: {
    flex: 1,
    minWidth: 0,

    '& .MuiOutlinedInput-root': {
      height: 45,
      borderRadius: '5px',
      fontSize: 14
    }
  },

  confirmButton: {
    flexShrink: 0,
    color: '#2EAE43',
  transition: 'none',

    '&.Mui-disabled': {
      color: '#A5D6A7'
    }
  },

  cancelAddButton: {
    flexShrink: 0,
    color: '#F44336',
     '&.Mui-disabled': {
      color: '#FFCDD2'
    },

  },

listWrapper: {
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  overscrollBehavior: 'contain',
  WebkitOverflowScrolling: 'touch',

  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
},

selectedList: {
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  overscrollBehavior: 'contain',
  WebkitOverflowScrolling: 'touch',

  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
},

  diagnosisRow: {
    minHeight: 40,
    flexShrink: 0,
    px: 1.5,
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    borderBottom: '1px solid #E0E0E0',

    '&:last-of-type': {
      borderBottom: 'none'
    },

    '&:hover': {
      bgcolor: '#FCF8F2'
    }
  },

  selectedDiagnosisRow: {
    bgcolor: '#FAFAFA',

    '&:hover': {
      bgcolor: '#FAFAFA'
    }
  },

  moveButton: {
    width: 25,
    height: 25,
    p: 0,
    flexShrink: 0,
    color: '#4A90D9',
    border: '1px solid #A9D3F5',
    borderRadius: '4px',

    '&:hover': {
      bgcolor: '#EEF7FE',
      borderColor: '#7BBCEB'
    },

    '&.Mui-disabled': {
      color: '#BDBDBD',
      borderColor: '#E0E0E0',
      bgcolor: '#F5F5F5'
    }
  },

  moveIcon: {
    fontSize: 19
  },

  diagnosisText: {
    minWidth: 0,
    color: '#424242',
    fontSize: 13,
    lineHeight: 1.4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  selectedRow: {
    minHeight: 40,
    flexShrink: 0,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    borderBottom: '1px solid #E0E0E0',

    '&:last-of-type': {
      borderBottom: 'none'
    }
  },

  selectedText: {
    minWidth: 0,
    color: '#424242',
    fontSize: 13,
    lineHeight: 1.4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  deleteButton: {
    width: 32,
    height: 32,
    flexShrink: 0,
    color: '#616161',

    '&:hover': {
      color: '#D32F2F',
      bgcolor: '#FDECEC'
    }
  },

  emptyState: {
    flex: '1 1 auto',
    minHeight: 0,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  emptyText: {
    color: '#9E9E9E',
    fontSize: 13,
    textAlign: 'center'
  }
};